"use client";

import { useUser } from "@/context/useUser";
import { useActivePeriod } from "@/hooks/useActivePeriod";
import AdminPackage from "@/components/private/paket/AdminPackage";

export default function Reports() {
    const { data: user, isLoading: loadingUser } = useUser();
    // activePeriod bisa null/undefined, tidak masalah
    const { data: activePeriod, isLoading: loadingPeriod } = useActivePeriod();

    if (loadingUser || loadingPeriod) {
        return <p></p>; // Atau Skeleton loading
    }

    // Cek user saja, karena activePeriod boleh kosong
    if (!user) {
        return <p>Data pengguna tidak tersedia</p>;
    }

    return (
        <AdminPackage user={user} activePeriod={activePeriod} />
    );
}